/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Status_FailedInputs */

const en_us2_body_assessment_status_failed = /** @type {(inputs: Body_Assessment_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This assessment couldn't be computed`)
};

const pt_br2_body_assessment_status_failed = /** @type {(inputs: Body_Assessment_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para calcular esta avaliação`)
};

const es_419_body_assessment_status_failed = /** @type {(inputs: Body_Assessment_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo calcular esta evaluación`)
};

const pt_pt2_body_assessment_status_failed = /** @type {(inputs: Body_Assessment_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível calcular esta avaliação`)
};

const fr_fr2_body_assessment_status_failed = /** @type {(inputs: Body_Assessment_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de calculer cette évaluation`)
};

const de_de2_body_assessment_status_failed = /** @type {(inputs: Body_Assessment_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Messung ließ sich nicht berechnen`)
};

const it_it2_body_assessment_status_failed = /** @type {(inputs: Body_Assessment_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile calcolare questa valutazione`)
};

/**
* | output |
* | --- |
* | "This assessment couldn't be computed" |
*
* @param {Body_Assessment_Status_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_status_failed = /** @type {((inputs?: Body_Assessment_Status_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Status_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_status_failed(inputs)
	if (locale === "es-419") return es_419_body_assessment_status_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_status_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_status_failed(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_status_failed(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_status_failed(inputs)
	return en_us2_body_assessment_status_failed(inputs)
});
export { body_assessment_status_failed as "body-assessment.status_failed" }